export default {
    state: {
        concerns: [],
        concern_id: null,
        errors: {},
        url: '/api/hms/inspections/concerns',
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name'},
                {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        form: {
            name: '',
        },
    },

    getters: {
        getConcernsMeta: state => state.meta,

        getConcernTableFields: state => state.table.fields,

        getConcernForm: state => state.form,

        getConcernErrors: state => state.errors,
    },

    mutations: {
        resetConcernsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setConcerns: (state, payload) => {
            state.concerns = payload;
        },

        setConcernsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setConcernErrors: (state, payload) => {
            state.errors = payload;
        },

        setConcernForm: state => {
            state.form = {
                name: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchConcerns: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setConcerns', response.data);

                        commit('setConcernsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setConcernErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchEditConcern: ({state, commit}, concern_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + concern_id + '/edit')
                    .then(response => {
                        state.concern_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitConcern: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setConcernErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateConcern: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.concern_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setConcernErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteConcern: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.concern_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
